<div id="intro-panel" [@simpleFadeAnimation]="'in'">
  shop-page works!
  <div class="fb-like" data-href="https://www.facebook.com/LoFi.gr/" data-width="250" data-layout="standard" data-action="like" data-size="large" data-show-faces="true" data-share="false"></div>
</div>
